<bw-action-article-legacy [brightsideWebFb]="{ event_name: statementType + '_statements' }">
  <div *ngIf="!modalMode" header-actions>
    <ui-nav-exit-back [trackingDetail]="{ event_name: statementType + '_statements' }"></ui-nav-exit-back>
  </div>
  <div *ngIf="!modalMode" header-title>
    <typography-legacy title-large color="var(--primary-text)">
      {{ statementsTitle | translate }}
    </typography-legacy>
  </div>
  <div content-section>
    <ng-container *ngIf="statementType === 'monthly'; else taxStatementsTemplate">
      <bw-bui-tile-legacy tileMargin="0 0 8px 0" class="mb-sm">
        <bui-tile-card-legacy cardBackground="var(--green-5)">
          <bw-bui-row-legacy rightIconName="headset" rightIconColor="green">
            <div class="row-content">
              <bw-bui-column-legacy
                [rowSpacing]="4"
                [rows]="[
                  { type: 'heading', content: 'STATEMENTS_NOTICE_TITLE' | translate, color: 'black' },
                  { type: 'paragraph', content: 'STATEMENTS_NOTICE_DESC' | translate, color: 'var(--secondary-text)' }
                ]"
              ></bw-bui-column-legacy>
            </div>
          </bw-bui-row-legacy>
        </bui-tile-card-legacy>
      </bw-bui-tile-legacy>
      <ng-container *ngIf="statements | async as statementsArray; else spinner">
        <ng-container *ngIf="statementsArray.length > 0; else noStatements">
          <div *ngFor="let year of statementsArray" class="mb-sm">
            <typography-legacy text-medium-regular color="var(--secondary-text)">
              {{ year.year }}
            </typography-legacy>
            <div>
              <bw-cell-legacy
                *ngFor="let statementItem of year.statements"
                (clicked)="downloadStatement($event, statementItem)"
                [labelLeft]="statementItem.month | monthName | uppercase | translate"
                iconNameRight="doc_download"
              ></bw-cell-legacy>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>

<ng-template #taxStatementsTemplate>
  <ng-container *ngIf="taxStatements | async as statementsArray; else spinner">
    <ng-container *ngIf="statementsArray.length > 0; else noStatements">
      <div>
        <bw-cell-legacy
          *ngFor="let statementItem of statementsArray"
          (clicked)="downloadStatement($event, statementItem)"
          [labelLeft]="statementItem.year"
          iconNameRight="doc_download"
        ></bw-cell-legacy>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #noStatements>
  <bw-bui-tile-legacy tileMargin="0 0 8px 0" class="mb-sm" tileBorder="1px solid var(--gray-10)">
    <bui-tile-card-legacy cardBackground="white">
      <bw-bui-row-legacy leftIconName="document">
        <div class="row-content">
          <bw-bui-column-legacy
            [rowSpacing]="4"
            [rows]="[{ type: 'paragraph', content: 'STATEMENTS_EMPTY_TITLE' | translate, color: 'var(--gray-30)' }]"
          ></bw-bui-column-legacy>
        </div>
      </bw-bui-row-legacy>
    </bui-tile-card-legacy>
  </bw-bui-tile-legacy>
</ng-template>
